import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InfrastructureIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M1.5 4.50049C1.5 5.29614 2.29018 6.0592 3.6967 6.62181C5.10322 7.18442 7.01088 7.50049 9 7.50049C10.9891 7.50049 12.8968 7.18442 14.3033 6.62181C15.7098 6.0592 16.5 5.29614 16.5 4.50049C16.5 3.70484 15.7098 2.94178 14.3033 2.37917C12.8968 1.81656 10.9891 1.50049 9 1.50049C7.01088 1.50049 5.10322 1.81656 3.6967 2.37917C2.29018 2.94178 1.5 3.70484 1.5 4.50049Z",
                stroke: "black",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.5 4.50049V8.99982C1.5 10.6565 4.858 11.9998 9 11.9998C13.142 11.9998 16.5 10.6572 16.5 8.99982V4.50049",
                stroke: "black",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.5 8.99976V13.4998C1.5 15.1564 4.858 16.4998 9 16.4998C13.142 16.4998 16.5 15.1564 16.5 13.4998V8.99976",
                stroke: "black",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
